/* eslint-disable no-lone-blocks */
import { Button, Drawer, Grid, Stack } from '@mui/material';
import React, { useContext, useState } from 'react';
import CustomMembersFilter from '../../../../../../../../components/Common/Resource/CustomMembersFilter';
import CustomRelationsFilter from '../../../../../../../../components/Common/Resource/CustomRelationsFilter';
import { IoMdAdd } from 'react-icons/io';
import StatusFilter from './StatusFilter';
import CustomCategoriesFilter from '../../../../../../../../components/Common/Resource/CustomCategoryFilter';
import CustomCompanyFilter from '../../../../../../../../components/Common/Resource/CustomCompanyFilter';
import CategoryFilter from '../../../../../../../../components/Common/CategoryFilter';
import CategorySlider from '../../CategorySlider';
import { LanguageContext } from '../../../../../../../../libs/Context';
import DateFilter from './DateFilter';
import AddlistMenu from '../AddListMenu';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import useResourceHelper from '../ContentCards/useResourceHelper';
import { useSelector } from 'react-redux';
import useContentPermissions from '../ContentCards/useContentPermissions';

const FilterHeader = (props) =>
{
	const {
		dateFilterValue,
		onDateFilterChange,
		statusFilterValue,
		onStatusFilterChange,
		memberFilterValue,
		onMemberFilterChange,
		categoryValue,
		onCategoryChange,
		relationFilterValue,
		onRelationFilterChange,
		companyFilterValue,
		onCompanyFilterChange
		// showStatusFilter = true
	} = props;
	const [ categoryType, setCategoryType ] = useState<'category' | 'subcategory' | 'playlist' | 'categoryData'>('category');
	const [ openCategory, setopenCategory ] = useState(false);
	const [ searchParams, setSearchParams ] = useSearchParams();
	const statusParam = searchParams.get('status') || '';
	const { categoryId } = useParams(); // Extract categoryId from URL parameters
	const { isAdminView, isNetworkResource } = useResourceHelper();
	const [ anchorElN, setAnchorElN ] = useState(null);
	const location = useLocation();
	const { language } = useContext(LanguageContext);
	const userConfigs = useSelector((state: any) => state?.mysession?.userConfigs);

	// Get content permissions
	const {
		isResourcesEnabled,
		isAllContentDisabled,
		isPlaylistsEnabled
	} = useContentPermissions();
	// Store path check in a variable
	const isNetworkPage = location.pathname.includes('/resource/network/companies');
	const companyId = isNetworkPage && useParams()?.companyId;
	const type = useParams()?.type || ''; // for resource user view

	const contentTypes = [ 'articles', 'videos', 'podcasts', 'documents', 'images', 'playlist' ];

	// Check if the status parameter is one of the predefined statuses
	const isPlaylistSection = [ 'playlists' ].includes(statusParam) || contentTypes.includes(type);
	const showStatusFilter = ![ 'drafts', 'published', 'unpublished', 'scheduled' ].includes(statusParam) &&
	isAdminView && (categoryId || statusParam === 'uncategorized');

	// Check if filters should be hidden based on content permissions
	// Note: Removed module enablement checks - users can view content even if modules are disabled
	const shouldHideFilters = !isResourcesEnabled;
	const isNotFromCompany = !window.location.pathname.includes('/resource/network/companies');
	const isNotNetworkPage = !window.location.pathname.includes('/resource/network');

	const handleClickMenu = (event) =>
	{
		setAnchorElN(event.currentTarget);
	};

	const handleCloseMenu = () =>
	{
		setAnchorElN(null);
	};

	// Comprehensive clear function that resets both props and URL parameters
	const handleClear = () =>
	{
		// Call all the onChange handlers with default/empty values
		if (onDateFilterChange) onDateFilterChange('ALL_TIME');
		if (onStatusFilterChange) onStatusFilterChange('all');
		if (onMemberFilterChange) onMemberFilterChange('all');
		if (onCategoryChange) onCategoryChange('all');
		if (onRelationFilterChange) onRelationFilterChange('all');
		if (onCompanyFilterChange) onCompanyFilterChange('all');

		// Clear filter-related URL parameters while preserving other parameters
		// Use the existing searchParams object and only delete specific parameters

		searchParams.delete('dateFilter');
		searchParams.delete('memberFilter');
		searchParams.delete('categoryFilter');
		searchParams.delete('statusFilter');
		searchParams.delete('relationFilter');
		searchParams.delete('companyFilter');
		searchParams.delete('sortField');
		searchParams.delete('sortDirection');

		// Clear additional network-specific parameters

		// Set default values for filters that read from URL params
		// searchParams.set('relationFilter', window.btoa('all'));
		// searchParams.set('companyFilter', window.btoa('all'));
		// searchParams.set('dateFilter', 'ALL_TIME');

		// Update the URL with the modified searchParams object
		setSearchParams(searchParams);
		// console.log('URL parameters cleared and reset to defaults');
	};

	// Return early with minimal/no content if filters should be hidden
	if (shouldHideFilters)
	{
		return <></>;
	}

	return (
		<Grid item borderTop={'1px solid #E4E4E4'} px={1} bgcolor={'#fff'}>
			<Grid
				container
				width={'100%'}
				alignItems={'center'}
				justifyContent={'space-between'}
				px={1}
				py={1}
			>
				<Grid item minWidth={0}>
					{!isNetworkPage &&
					<Stack flexWrap={'wrap'} direction={'row'} alignItems={'end'} spacing={1}>
						{!isPlaylistSection && (
							<CustomCategoriesFilter
								labelText={!categoryId ? 'Categories' : 'Subcategories'}
								value={categoryValue}
								onChange={onCategoryChange}
							/>
						)}
						<CustomMembersFilter
							labelText='Members'
							value={memberFilterValue}
							onChange={onMemberFilterChange}
						/>
						<DateFilter
							value={dateFilterValue}
							onChange={onDateFilterChange}
						/>
						{showStatusFilter && (
							<StatusFilter
								value={statusFilterValue}
								onChange={onStatusFilterChange}
							/>
						)}
						<Button variant='text' size='small' onClick={handleClear}>{language?.clear}</Button>
					</Stack>}
					{isNetworkPage &&
					<Stack direction={'row'} alignItems={'end'} spacing={1}>
						{isNetworkPage && type === 'categories' &&
						<CustomCategoriesFilter
							labelText={!categoryId ? 'Categories' : 'Subcategories'}
							value={categoryValue}
							onChange={onCategoryChange}
						/>}
						{!(isNetworkPage && type === 'categories') &&
						<CustomCompanyFilter
							labelText='Companies'
							value={companyFilterValue}
							onChange={onCompanyFilterChange}
						/>}
						{!companyId &&
						<CustomRelationsFilter
							labelText='Relations'
							value={relationFilterValue}
							onChange={onRelationFilterChange}
						/>
						}
						{(isNotFromCompany || window.location.pathname.includes('/categories')) &&
						<DateFilter
							value={dateFilterValue}
							onChange={onDateFilterChange}
						/>}
						<Button variant='text' size='small' onClick={handleClear}>{language?.clear}</Button>
					</Stack>}
				</Grid>
				<Grid item>
					<Stack direction={'row'} spacing={1.5}>
						{(isNotNetworkPage && isNotFromCompany) && <CategoryFilter/>}
						{isAdminView && userConfigs?.employeePermissions?.permissions?.create && (
							<Button onClick={handleClickMenu} variant='contained' sx={{ color: 'var(--whiteColor)' }} size='small' startIcon={<IoMdAdd color='var(--whiteColor)'/>}>
								{language?.new}
							</Button>
						)}
					</Stack>
				</Grid>
			</Grid>
			<AddlistMenu anchorEl={anchorElN} handleClose={handleCloseMenu}
				setOpenCategory={setopenCategory} setCategoryType={setCategoryType}
			/>
			<Drawer anchor='right' open={openCategory} onClose={() => setopenCategory(false)}
				sx={{ zIndex: '1015 !important' }}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '35%'
						}
					}
				}}
			>
				<CategorySlider toggleCategory={() => setopenCategory(false)}
					categoryType={categoryType}
				/>
			</Drawer>
		</Grid>
	);
};

export default FilterHeader;
